import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/Button';
import Col from '../../components/Col';
import Form from '../../components/Form';
import Row from '../../components/Row';
import Card from '../../components/Card';
import ContactPicker from './ContactPicker';
import { clearAvailableServiceTimes } from 'src/store/actions/availableServiceTimes';
import { selectValidation } from 'src/store/selectors/Validation';
import { selectFormLoader } from 'src/store/selectors/FormLoader';
import Loader from '../../components/Loader';
import { clearValidation } from 'src/store/actions/validation';
import { clearSuiteUsers } from 'src/store/actions/suites';
import './ServiceRequestScheduleForm.scss';

// Extracted UI component for the provider selection UI.
const ProviderSelectionCard = ({
  from,
  setFormData,
  serviceRequest,
  isLegacyTable,
}) => (
  <Row mdCenter>
    <Col xs="12" md="6">
      <Row>
        <Card
          title={
            <div style={{ textAlign: 'center' }}>
              Please select from the following list of Service Providers,
              Service Managers or Property Developers.
            </div>
          }
          body={
            <ContactPicker
              from={from}
              setFormData={setFormData}
              serviceRequest={serviceRequest}
              isLegacyTable={isLegacyTable}
            />
          }
        />
        <br />
        <br />
      </Row>
    </Col>
  </Row>
);

export const ServiceRequestAssignForm = ({
  onClose,
  serviceRequest,
  handleStatusChange,
  from,
  isLegacyTable,
}) => {
  // State using a single object to match class component structure.
  const [state, setState] = useState<any>({
    formData: {},
    availableServiceTimes: [],
    isEventShow: false,
    openCalendly: '',
  });

  // Redux using hooks.
  const dispatch = useDispatch();
  const validation = useSelector(selectValidation);
  const loader = useSelector(selectFormLoader);

  // This effect runs once on mount only (empty dependency array), mimicking componentDidMount in the old class component.
  useEffect(() => {
    dispatch(clearAvailableServiceTimes());
    dispatch(clearSuiteUsers());
  }, []);

  // This effect replaces componentDidUpdate in the old class component for validation changes.
  useEffect(() => {
    if (validation.status && validation.message === 'Schedule') {
      onClose();
      dispatch(clearValidation());
    }
  }, [validation, onClose, dispatch]);

  // Form data update function - replaces setFormData method.
  const setFormData = (e: any) => {
    setState((prevState: any) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        ...e,
      },
    }));
  };

  // Destructure formData from state for cleaner access.
  const { formData } = state;

  return (
    <Form
      headline="Service Request Assignment."
      onClose={() => {
        onClose();
        dispatch(clearValidation());
      }}
      onSubmit={() => {
        handleStatusChange(formData, serviceRequest.id);
        setState((prevState: any) => ({
          ...prevState,
          formData: {},
          availableServiceTimes: [],
        }));
      }}
      actions={
        <>
          {loader ? <Loader center={true} /> : null}
          <Button
            color="semantic"
            size="small"
            label="Cancel"
            onClick={() => {
              onClose();
              dispatch(clearValidation());
            }}
            style={{ marginRight: '1.5rem' }}
          />
          <Button
            color="teal"
            size="small"
            label="Assign"
            disabled={!formData.userId}
          />
        </>
      }
      component={
        <ProviderSelectionCard
          from={from}
          setFormData={setFormData}
          serviceRequest={serviceRequest}
          isLegacyTable={isLegacyTable}
        />
      }
      footer={undefined}
      strapline={undefined}
      onExit={undefined}
    />
  );
};

export default ServiceRequestAssignForm;
